import { Component, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { MatTable } from '@angular/material/table';
import { DataBagService } from 'src/app/common/data-bag.service';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { OptionalTripLocationAddComponent } from './optional-trip-location-add/optional-trip-location-add.component';

export interface PeriodicElement {
	name: string;
	weight: number;
	symbol: string;
}

@Component({
	selector: 'app-optional-trip-locations',
	templateUrl: './optional-trip-locations.component.html',
	styleUrls: ['./optional-trip-locations.component.css'],
})
export class OptionalTripLocationsComponent {
	@Input() data: any;
	@Input() editable = true;
	@Output() dataChanged = new EventEmitter();
	@ViewChild('dataTable') table: MatTable<PeriodicElement>;
	locations: Array<any> = [];
	displayedColumns: string[] = ['name', 'code', 'kind', `edit`];
	dialogConfig: MatDialogConfig;
	dialogWithForm: MatDialogRef<OptionalTripLocationAddComponent>;

	constructor(
		private readonly bag: DataBagService,
		private readonly dialogModel: MatDialog,
	) {}

	dialogForm() {
		this.bag.get('/location/?limit=9999', (result, error) => {
			this.locations = result.results;
			const dialogWithForm = this.dialogModel.open(OptionalTripLocationAddComponent, {
				width: '400px',
				data: {
					locations: result.results,
					optionalTripLocations: [],
				},
			});

			dialogWithForm.afterClosed().subscribe((result) => {
				const duplicate = this.data.optionalTripLocations.filter(
					(obj) => obj.location.id == result.optionalTripLocations.id,
				);

				if (
					result === undefined ||
					result.optionalTripLocations === undefined ||
					result.optionalTripLocations === null ||
					result.optionalTripLocations.length === 0 ||
					duplicate.length != 0
				) {
					return;
				}
				this.data.optionalTripLocations.push({
					id: null,
					location: result.optionalTripLocations,
					order: this.data.optionalTripLocations.length + 1,
				});
				this.data.optionalTripLocations.forEach((obj) => {
					if (obj.location.locationKind === 'RG') {
						obj.location.locationKind = 'Region';
					} else if (obj.location.locationKind === 'CT') {
						obj.location.locationKind = 'Miasto';
					} else if (obj.location.locationKind === 'CR') {
						obj.location.locationKind = 'Państwo';
					}
				});
				this.table.renderRows();
			});
		});
	}

	deleteLocation(index) {
		this.data.optionalTripLocations.splice(index, 1);
		this.table.renderRows();
	}
}
